import styled, { css } from 'styled-components';
import { minBp } from 'src/lib/theme';
import Input from 'components/_form/Input/Input';
import Button from 'components/Button/Button';
import _ChevronDown from 'src/assets/icons/chevron-down.svg';

export const Wrap = styled.div`
  padding: 40px;
  width: 100%;
  height: 100%;
  height: 100vh;
  overflow: auto;
  padding-bottom: 150px;

  @media ${minBp('desktop')} {
    display: flex;
    padding: 50px;
  }
`;

export const Details = styled.div`
  @media ${minBp('desktop')} {
    width: 40%;
  }
`;

export const Locator = styled.div`
  @media ${minBp('desktop')} {
    padding-left: 60px;
    width: 60%;
  }
`;

export const Heading = styled.h4`
  margin: 0 0 20px;
  font-size: 17px;
  text-transform: uppercase;
`;

export const Description = styled.p`
  margin: 0 0 35px;
  color: #000;
`;

export const FormFieldGroup = styled.div`
  margin-bottom: 28px;
`;

export const PostCodeLookupWrap = styled.div`
  margin: 0 0 20px;
`;

export const FormLabel = styled.label`
  ${({ theme }) => `
    display: block;
    font-family: inherit;
    font-size: inherit;
    margin-bottom: 10px;
    color: #000;

    span {
      color: ${theme.colors.primary};
    }
  `}
`;

export const FormInput = styled(Input)`
  width: 100%;
`;

export const InputError = styled.div`
  ${({ theme }) => `
    color: ${theme.colors.primary};
    font-family: ${({ theme }) => theme.fonts.dinDemi};
    font-weight: 500;
    font-size: 14px;
    margin-top: 10px;
  `}
`;

export const LocationLookup = styled.div`
  @media ${minBp('tablet')} {
    display: flex;
    align-items: center;
  }
`;

export const PostCodeInput = styled(Input)`
  flex: 1;
  width: 100%;
  margin-right: 10px;

  @media ${minBp('tablet')} {
    margin-right: 18px;
  }
`;

export const SearchButton = styled(Button)`
  width: auto;
`;

export const PostCodeSearchWrap = styled.div`
  display: flex;

  @media ${minBp('tablet')} {
    flex: 1;
  }
`;

export const Or = styled.div`
  font-size: 17px;
  font-weight: 500;
  font-family: ${({ theme }) => theme.fonts.dinDemi};
  color: #000;
  text-transform: uppercase;
  padding: 18px 0;
  text-align: center;

  @media ${minBp('tablet')} {
    padding: 0 18px;
    text-align: left;
  }
`;

export const GeoButton = styled(Button)`
  width: 100%;

  @media ${minBp('tablet')} {
    width: auto;
  }
`;

export const Radios = styled.div`
  margin-bottom: 25px;

  @media ${minBp('desktop')} {
    margin-bottom: 15px;
  }
`;

export const Checkboxes = styled.div`
  margin-bottom: 35px;

  @media ${minBp('tablet')} {
    margin-top: 10px;
    margin-bottom: 0;
  }
`;

export const CheckboxWrapper = styled.div`
  margin: 0 0 18px;
  font-size: 14px;
  color: #000;
`;

export const ChooseLocationWrap = styled.div`
  margin: 0 0 16px;
`;

export const CountrySelectorWrap = styled.div`
  position: relative;
  margin-left: 0.5rem;
  display: inline-block;

  svg {
    position: absolute;
    top: 0;
    right: 8px;
    width: 16px;
    height: 16px;
    pointer-events: none;
  }
`;

export const CountrySelector = styled.select`
  appearance: none;
  border: 0;
  border-radius: 0;
  padding: 0 30px 0 0;
  margin: 0;
  background: transparent;
  width: 100%;
  text-align: left;
  font-family: inherit;
  font-size: 16px;
  color: inherit;
  font-weight: 500;
  font-family: ${({ theme }) => theme.fonts.dinDemi};
`;

export const SendButton = styled(Button)`
  width: 100%;
  margin-top: 25px;

  @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
    margin-bottom: 25px;
  }
`;

export const Results = styled.div`
  margin-bottom: 20px;

  @media ${minBp('tablet')} {
    display: flex;
    flex-wrap: wrap;
    margin: 0 0 20px -4px;
    width: calc(100% + 8px);
  }
`;

export const ResultCard = styled.div`
  ${({ theme, selected }) => `
    margin: 0 0 8px;
    border-radius: 4px;
    border: 2px solid ${selected ? '#b5b5b5' : '#eee'};
    background: ${selected ? '#f1f1f1' : 'inherit'};
    padding: 25px;
    cursor: pointer;

    @media ${minBp('tablet')} {
      margin: 4px;
      width: calc(50% - 8px);
    }
  `}
`;

export const ResultTitle = styled.h4`
  text-transform: uppercase;
  font-size: 16px;
`;

export const ResultAddress = styled.div`
  color: #000;
  margin-bottom: 15px;
  white-space: pre-wrap;
`;

export const ResultDistance = styled.div`
  font-size: 14px;
`;

export const SuccessWrap = styled.div`
  padding: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  height: 100%;

  @media ${minBp('desktop')} {
    padding: 50px;
  }
`;

export const SuccessCircle = styled.div`
  ${({ theme }) => `
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    background-color: ${theme.colors.primary};
    border-radius: 50%;

    svg {
      width: 20px;
      height: 20px;

      path {
        fill: white;
      }
    }
  `}
`;

export const SuccessTitle = styled.h2`
  ${({ theme }) => `
    margin-bottom: 15px;
    font-size: 32px;
    font-family: ${({ theme }) => theme.fonts.dinDemi};
    font-weight: 500;
    text-transform: uppercase;
  `}
`;

export const SuccessDescription = styled.div`
  ${({ theme }) => `
    margin-bottom: 20px;
    color: #000;
  `}
`;

export const SharedTextStyles = css`
  color: #000;
  font-size: 14px;
`;

export const Text = styled.p`
  ${SharedTextStyles}
  margin-bottom: 8px;
`;

export const ContentToggle = styled.span`
  ${SharedTextStyles}
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-bottom: 6px;

  ${({ isActive }) => `
    ${ChevronDown} {
      transform: ${isActive ? 'rotate(180deg)' : 'rotate(0)'};
    }
  `}
`;

export const ChevronDown = styled(_ChevronDown)`
  margin: 4px;
  width: 12px;
  height: 12px;

  path {
    ${({ theme }) => `
      fill: ${theme.colors.primary};
    `}
  }
`;

export const AdditionalContent = styled.p`
  ${SharedTextStyles}

  ${({ isActive }) => `
    display: ${isActive ? 'block' : 'none'};
  `}
`;
